export default __webpack_public_path__ + "static/media/www.7d732fec.svg";